import ArticleListingCard from "../../../components/articleListingCard/articleListingCard";

import styles from "./oneColumnArticleListingLayout.module.scss"

function OneColumnArticleListingLayout({ articles }) {
  return (
    <div className={`${styles.articleListingWrapper} view`}>
      {articles.map((a)=>(
        <div className={styles.articleCardSpacer} key={a.uuid}>
          <ArticleListingCard
            layout="inline"
            slug={a.slug}
            thumbnail={a.content.thumbnail}
            article_category={a.content.category}
            article_type={a.content.article_type}
            authors={a.content.authors}
            title={a.content.headline}
            summary={a.content.lead}
            date={a.content.created_at}
            comment_count={5}
            enable_comments={a.content.has_comments}
            enable_social_sharing={a.content.has_social_sharing}
            use_legacy_thumbnail_background={a.content.legacy_thumbnail_background}
          />
        </div>
      ))}
    </div>
  );
}

export default OneColumnArticleListingLayout;
